import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { mobileOrNarrower } from '@upright/ui/common/generic/layout/breakpoint-utils';
import styled, { css } from 'styled-components';
import { IconCell } from './icon-cell';
import { TextCell } from './text-cell';
import { SubscriptionTableLayout } from './types';

interface Props {
  featureText: string;
  isBasic?: boolean;
  isStandard?: boolean;
  isAdvanced?: boolean;
  tooltipText?: string;
  layout: SubscriptionTableLayout;
}

export const SubscriptionTableRow = (props: Props) => {
  return (
    <TableRow layout={props.layout}>
      <TextCell text={props.featureText} tooltipText={props.tooltipText} />
      {props.isBasic ? <IconCell /> : <IconCell isEmpty />}
      {props.isStandard ? <IconCell /> : <IconCell isEmpty />}
      {props.isAdvanced ? <IconCell /> : <IconCell isEmpty />}
    </TableRow>
  );
};

const TableRow = styled.tr<{ layout: SubscriptionTableLayout }>`
  overflow: hidden;
  border-bottom: 1px solid ${BouColor.TOOL_BORDER_LIGHT_GRAY};
  > td {
    padding: ${props => (props.layout === 'tight' ? '0.75em' : '1em')};
    border-left: 1px solid ${BouColor.TOOL_BORDER_LIGHT_GRAY};
  }
  > td:first-child {
    border: none;
    line-clamp: 2;
    ${mobileOrNarrower(css`
      width: 70vw;
    `)};
  }
  > td:not(:first-child) {
    width: 12em;
  }
`;
